// store.js
import { reactive, toRef } from "vue";

export const store = reactive({
    desktopCtaMessage: {
        title: 'Join Thousands Profiting From Smart Trades!',
        buttonText: 'TRADE LIKE TIM',
        link: "https://www.timothysykes.com/millionaire-challenge/?utm_source=blog&utm_medium=popup&utm_campaign=Qhdzor"
    },
    showCookieConsentBanner: false,
    hasAdblocker: true,
    commentToReply: null,
    commentToReplyName: null,
    contentSidebar: {
        show: false,
        sidebarId: null,
        data: null,
        postTags: null,
        slug: null
    },
    postId: null,
    isLoading: false,
    isContentDoneLoading: false,
    setDesktopCtaMessage(payload) {
        this.desktopCtaMessage = payload
    },
    toggleAdBlocking(value) {
        if (process.client) {
            this.hasAdblocker = value;
        }
    },
    toggleLoading() {
        if (process.client) {
            this.isLoading = !this.isLoading;
        }
    },
    manualToggleLoading(val) {
        if (process.client) {
            this.isLoading = val;
        }
    },
    toggleContentSidebarVisibility(visibility) {
        if (process.client) {
            this.contentSidebar = { ...this.contentSidebar, show: visibility };
        }
    },
    setContentSidebarId(id) {
        if (process.client) {
            this.contentSidebar = { ...this.contentSidebar, sidebarId: id };
        }
    },
    setContentSidebarTitle(slug) {
        if (process.client) {
            this.contentSidebar = { ...this.contentSidebar, slug };
        }
    },
    setPostsTags(tags) {
        if (process.client) {
            this.contentSidebar = { ...this.contentSidebar, postTags: [...tags] };
        }
    },
    setContentSidebarData(payload) {
        if (process.client) {
            this.contentSidebar = { ...this.contentSidebar, data: payload };
        }
    },
    changePostId(payload) {
        if (process.client) {
            this.postId = payload
        }
    },
    contentDoneLoading() {
        if (process.client) {
            this.isContentDoneLoading = false;
            setTimeout(() => {
                this.isContentDoneLoading = true;
            }, 500)
        }
    },
    setCommentIdToReply(payload) {
        if (process.client) {
            this.commentToReply = payload.id
            this.commentToReplyName = payload.name
        }
    },
    toggleCookieConsentBanner(payload) {
        if (process.client) {
            this.showCookieConsentBanner = payload
        }
    }
});

export const commentToReplyNameRef = toRef(store, "commentToReplyName");
